import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CustomAlert from './CustomAlert';
import LanguageSelector from '../components/languageSelector';
import { API_BASE_URL } from '../config/constants';

function UserAuthentication() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [sEmail, setSEmail] = useState('');
  const [sPassword, setSPassword] = useState('');
  const [error, setError] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState('');
  const [reenterPassword, setReenterPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [otpStatus, setOtpStatus] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showSignupPassword, setShowSignupPassword] = useState(false);
  const [shakeFields, setShakeFields] = useState([]);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const [passwordValidations, setPasswordValidations] = useState({
    hasLowercase: false,
    hasUppercase: false,
    hasNumber: false,
    hasSpecialChar: false,
    hasMinLength: false,
  });
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleSignupPasswordVisibility = () => setShowSignupPassword(!showSignupPassword);
  const closeModalAndSwitchToLogin = () => {
    setShowModal(false);
    setIsLogin(true);
  };
  const validatePassword = (value) => {
    setPasswordValidations({
      hasLowercase: /[a-z]/.test(value),
      hasUppercase: /[A-Z]/.test(value),
      hasNumber: /[0-9]/.test(value),
      hasSpecialChar: /[^a-zA-Z0-9]/.test(value),
      hasMinLength: value.length >= 8,
    });
  };
  const handleSignupPasswordChange = (e) => {
    const value = e.target.value;
    setSPassword(value);
    validatePassword(value);
  };
  const onSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", sEmail);
    formData.append("password", sPassword);
    formData.append("contactNumber", mobileNumber);
    try {
      const response = await axios.post(`${API_BASE_URL}auth/register`, formData);
      if (response.status === 201) {
        setShowModal(true);
        setEmail(sEmail);
        setPassword(sPassword);
        setName('');
        setSEmail('');
        setSPassword('');
        setMobileNumber('');
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          setError(t('errorEmailPhoneInUse'));
        } else {
          setError(t('errorGeneric'));
        }
      } else {
        setError(t('errorNetwork'));
      }
    } finally {
      setLoading(false);
    }
  };
  const onLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const formData = {
      email: email,
      password: password,
    };
    try {
      const response = await axios.post(`${API_BASE_URL}auth/login`, formData);
      if (response.status === 200) {
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem('id', response.data.data.user.id);
        sessionStorage.setItem('token', response.data.data.token);
        sessionStorage.setItem('name', response.data.data.user.name);
        sessionStorage.setItem('email', response.data.data.user.email);
        sessionStorage.setItem('contact', response.data.data.user.contact);
        const { fareData, weightageData, waitSlabData } = response.data.data;
        if (fareData) localStorage.setItem('fareData', JSON.stringify(fareData));
        if (weightageData) localStorage.setItem('weightageData', JSON.stringify(weightageData));
        if (waitSlabData) localStorage.setItem('waitSlabData', JSON.stringify(waitSlabData));
        navigate('/booking');
      }
    } catch (error) {
      setError(t('Please Check Your Email or Password'));
    } finally {
      setLoading(false);
    }
  };
  const handleOtpChange = async (e) => {
    const input = e.target.value;
    if (/^\d{0,6}$/.test(input)) {
      setOtp(input);
      if (input.length === 6) {
        try {
          const isValid = await verifyOtpWithoutAlert(input);
          setOtpStatus(isValid ? 'success' : 'failed');
        } catch (error) {
          console.error('Error verifying OTP:', error);
          setOtpStatus('failed');
        }
      } else {
        setOtpStatus('');
      }
    }
  };
  const verifyOtpWithoutAlert = async (input) => {
    try {
      const response = await axios.post(`${API_BASE_URL}auth/validate-otp`, { email: sEmail, otp: input });
      return response.status === 200;
    } catch (error) {
      console.error('Error verifying OTP:', error.response ? error.response.data : error.message);
      return false;
    }
  };
  const sendOtp = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}auth/verify-email`, { email: sEmail });
      if (response.status === 200) {
        setIsOtpSent(true);
        setAlertMessage('OTP sent to email successfully!');
        setShowAlert(true);
      }
    } catch (error) {
      console.error('Error sending OTP:', error.response ? error.response.data : error.message);
      if (error.response && error.response.status === 404) {
        setAlertMessage('Email already registered. Please use a different email or log in.');
      } else {
        setAlertMessage('Failed to send OTP. Please try again!');
      }
      setShowAlert(true);
      setShowModal(false);
    }
  };
  return (
    <div className='background-image-login'>
      <div className={`app ${loading ? 'loading' : ''}`}>
        <div className='loginbox'>
          <div className='logo'>
            <img src="/images/CIAL_Logo.png" alt="Logo" />
          </div>
          <div className="header-text" dangerouslySetInnerHTML={{ __html: t("title") }} />
          <div className="options">
            <div
              className={`option-text ${isLogin ? 'active' : ''}`}
              onClick={() => { setIsLogin(true); setError(false) }}

            >
              {t('login')}
            </div>
            <div className="separator"></div>
            <div
              className={`option-text ${!isLogin ? 'active' : ''}`}
              onClick={() => { setIsLogin(false); setError(false) }}
            >
              {t('signup')}
            </div>
          </div>
          <div className="login-form">
            {error && <p className="error">{error}</p>}
            {isLogin ? (
              <form onSubmit={onLogin}>
                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t('enterEmail')}
                    required
                  />
                </div>
                <div className="form-group">
                  <div className="password-input-container">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder={t('enterPassword')}
                      required
                    />
                    <button
                      type="button"
                      className="toggle-password"
                      onClick={togglePasswordVisibility}
                    >
                      <img src={showPassword ? "/images/eye-open.png" : "/images/eye-closed.png"} alt="Toggle password visibility" />
                    </button>
                  </div>
                </div>
                <button type="submit" className="grey-button">{t('loginButton')}</button>
              </form>
            ) : (
              <form onSubmit={onSignup}>
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder={t('enterName')}
                    required
                  />
                </div>
                <div className="form-group">
                  <div className="email-otp-container">
                    <input
                      type="email"
                      id="email"
                      value={sEmail}
                      onChange={(e) => setSEmail(e.target.value)}
                      placeholder={t('enterEmail')}
                      required
                    />
                    <button
                      type="button"
                      onClick={sendOtp}
                      className="otp-button"
                    >
                      {isOtpSent ? t('Re-Send OTP') : "Send OTP"}
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <div className="otp-input-container">
                    <input
                      type="text"
                      id="otp"
                      value={otp}
                      onChange={(e) => { handleOtpChange(e) }}
                      placeholder={t('Enter your OTP')}
                      maxLength={6}
                      required
                    />
                    {otp.length === 6 && otpStatus && (
                      <img
                        src={
                          otpStatus === 'success'
                            ? '/images/verify_otp.png'
                            : '/images/verify_otp_failed.png'
                        }
                        alt={
                          otpStatus === 'success'
                            ? t('OTP Verified')
                            : t('OTP Verification Failed')
                        }
                        className="verify-otp-image"
                      />
                    )}
                    {showAlert && <CustomAlert message={alertMessage} onClose={handleCloseAlert} />}
                  </div>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="mobileNumber"
                    value={mobileNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setMobileNumber(value);
                      }
                    }}
                    placeholder={t('Enter your Mobile Number')}
                    required
                    maxLength={10}
                  />
                </div>
                <div className="form-group">
                  <div className="password-input-container">
                    <input
                      type={showSignupPassword ? 'text' : 'password'}
                      id="password"
                      value={sPassword}
                      onChange={handleSignupPasswordChange}
                      placeholder={t('enterPassword')}
                      required
                    />
                    <button
                      type="button"
                      className="toggle-password"
                      onClick={toggleSignupPasswordVisibility}
                    >
                      <img
                        src={showSignupPassword ? "/images/eye-open.png" : "/images/eye-closed.png"}
                        alt="Toggle password visibility"
                      />
                    </button>
                  </div>
                  {sPassword && (
                    <div className="password-validations">
                      <p className={passwordValidations.hasLowercase ? 'valid' : 'invalid'}>
                        {passwordValidations.hasLowercase ? '✔' : '✖'} One lowercase character
                      </p>
                      <p className={passwordValidations.hasUppercase ? 'valid' : 'invalid'}>
                        {passwordValidations.hasUppercase ? '✔' : '✖'} One uppercase character
                      </p>
                      <p className={passwordValidations.hasNumber ? 'valid' : 'invalid'}>
                        {passwordValidations.hasNumber ? '✔' : '✖'} One number
                      </p>
                      <p className={passwordValidations.hasSpecialChar ? 'valid' : 'invalid'}>
                        {passwordValidations.hasSpecialChar ? '✔' : '✖'} One special character
                      </p>
                      <p className={passwordValidations.hasMinLength ? 'valid' : 'invalid'}>
                        {passwordValidations.hasMinLength ? '✔' : '✖'} 8 characters minimum
                      </p>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <div className="password-input-container">
                    <input
                      type={showSignupPassword ? 'text' : 'password'}
                      id="reenter-password"
                      value={reenterPassword}
                      onChange={(e) => setReenterPassword(e.target.value)}
                      placeholder={t('Re-enter your password')}
                      required
                    />
                    <button
                      type="button"
                      className="toggle-password"
                      onClick={toggleSignupPasswordVisibility}
                    >
                      <img
                        src={showSignupPassword ? "/images/eye-open.png" : "/images/eye-closed.png"}
                        alt="Toggle password visibility"
                      />
                    </button>
                  </div>
                </div>
                <button
                  type="submit"
                  className="grey-button"
                  onClick={async (e) => {
                    e.preventDefault();
                    const missingFields = [];
                    if (!name) missingFields.push('name');
                    if (!sEmail) missingFields.push('email');
                    if (!sPassword) missingFields.push('password');
                    if (!reenterPassword) missingFields.push('reenterPassword');
                    if (!mobileNumber || mobileNumber.trim() === '') missingFields.push('mobileNumber');
                    if (!otp) missingFields.push('otp');

                    if (missingFields.length > 0) {
                      setAlertMessage(
                        `Please fill in the following fields: ${missingFields.join(', ')}.`
                      );
                      setShowAlert(true);
                      setShakeFields(missingFields);
                      setTimeout(() => setShakeFields([]), 500);
                      return;
                    }
                    if (sPassword !== reenterPassword) {
                      setAlertMessage('Password doesn’t match. Please try again.');
                      setShowAlert(true);
                      setShakeFields(['password', 'reenterPassword']);
                      setTimeout(() => setShakeFields([]), 500);
                      return;
                    }
                    try {
                      await onSignup(e);
                    } catch (error) {
                      setAlertMessage('LOGIN FAILED: Signup process encountered an error.');
                      setShowAlert(true);
                      return;
                    }
                  }}
                  disabled={
                    !otp ||
                    !Object.values(passwordValidations).every(Boolean) ||
                    !sEmail ||
                    !sPassword ||
                    !reenterPassword ||
                    !mobileNumber ||
                    !name
                  }
                >
                  {t('signupButton')}
                </button>
              </form>
            )}
          </div>
          {showModal && (
            <div className="modal-overlay" onClick={closeModalAndSwitchToLogin}>
              <div className="modal-content">
                <img src="/images/success-icon.png" alt="Success" className="modal-success-image" />
                <p className="success-message">{t('signupSuccess')}</p>

                <img
                  src="/images/loginbutton.png"
                  alt={t('login')}
                  className="login-button"
                  onClick={closeModalAndSwitchToLogin}
                />
              </div>
            </div>
          )}
          <div className="copyright">
            © 2025 ALL RIGHTS RESERVED
          </div>
        </div>
        <LanguageSelector />
      </div>
    </div>
  );
}
export default UserAuthentication;
